import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
  },
  form: {
    height: '100%',
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '30%',
    margin: '0 auto',
  },
}));

export default useStyles;
